import { render, staticRenderFns } from "./gj-select.vue?vue&type=template&id=e3948d8c&scoped=true&"
import script from "./gj-select.vue?vue&type=script&lang=js&"
export * from "./gj-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-select.vue?vue&type=style&index=0&id=e3948d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3948d8c",
  null
  
)

export default component.exports